/*
 * card-color-swatches.js
 * Adds hover image-swap to color swatches rendered by snippets/card-color-swatches.liquid.
 * On hover over a swatch with [data-color-swap-image], the card's primary image src is
 * swapped to the linked color product's featured image. On mouseleave, original is restored.
 *
 * No-op on touch devices (no hover state). Click still works as a normal link.
 * Re-initialises after ajaxinate pagination and facet updates.
 */
(function () {
  var SWATCH_SEL = '[data-card-color-swatches] .card-color-swatch[data-color-swap-image]';

  function findContainer(swatch) {
    // Wrapper snippet wraps card + swatches together.
    return (
      swatch.closest('.card-with-swatches') ||
      swatch.closest('.card-wrapper') ||
      swatch.closest('.collection__item') ||
      swatch.closest('li')
    );
  }

  function findCardImage(container) {
    if (!container) return null;
    return (
      container.querySelector('.card_product_swiper .swiper-slide:first-child img') ||
      container.querySelector('.card_product_swiper img') ||
      container.querySelector('.card__media img') ||
      container.querySelector('.card-wrapper img') ||
      container.querySelector('img')
    );
  }

  function bindSwatch(swatch) {
    if (swatch.dataset.colorSwapBound === '1') return;
    swatch.dataset.colorSwapBound = '1';

    var container = findContainer(swatch);
    var img = findCardImage(container);
    var newSrc = swatch.getAttribute('data-color-swap-image');
    if (!img || !newSrc) return;

    var originalSrc = img.getAttribute('src');
    var originalSrcset = img.getAttribute('srcset');

    swatch.addEventListener('mouseenter', function () {
      img.setAttribute('src', newSrc);
      if (originalSrcset) img.removeAttribute('srcset');
    });
    swatch.addEventListener('mouseleave', function () {
      img.setAttribute('src', originalSrc);
      if (originalSrcset) img.setAttribute('srcset', originalSrcset);
    });
  }

  function init() {
    document.querySelectorAll(SWATCH_SEL).forEach(bindSwatch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('ajaxinate:load', function () { setTimeout(init, 50); });
  document.addEventListener('facet:updated', function () { setTimeout(init, 350); });
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
